/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Conference backend
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ConferenceBackend) {
      root.ConferenceBackend = {};
    }
    root.ConferenceBackend.Params = factory(root.ConferenceBackend.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Params model module.
   * @module model/Params
   * @version 0.0.1
   */

  /**
   * Constructs a new <code>Params</code>.
   * @alias module:model/Params
   * @class
   * @param deviceId {String} 
   * @param presentationId {String} 
   * @param rating {Number} 
   */
  var exports = function(deviceId, presentationId, rating) {
    var _this = this;

    _this['deviceId'] = deviceId;
    _this['presentationId'] = presentationId;
    _this['rating'] = rating;
  };

  /**
   * Constructs a <code>Params</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Params} obj Optional instance to populate.
   * @return {module:model/Params} The populated <code>Params</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('deviceId')) {
        obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
      }
      if (data.hasOwnProperty('presentationId')) {
        obj['presentationId'] = ApiClient.convertToType(data['presentationId'], 'String');
      }
      if (data.hasOwnProperty('rating')) {
        obj['rating'] = ApiClient.convertToType(data['rating'], 'Number');
      }
    }
    return obj;
  }

  /**
   * @member {String} deviceId
   */
  exports.prototype['deviceId'] = undefined;
  /**
   * @member {String} presentationId
   */
  exports.prototype['presentationId'] = undefined;
  /**
   * @member {Number} rating
   */
  exports.prototype['rating'] = undefined;



  return exports;
}));






// WEBPACK FOOTER //
// ./generated/src/model/Params.js